import React, { useState } from 'react';

import { PatientHistoryQuestionKey } from '../constants';
import {
  Box,
  SectionTitle,
  MaterialIcons,
  Paper,
  MaterialUICore,
} from '@iclinic/design-system';
import PatientHistoryQuestion from './PatientHistoryQuestion';
import useStyles from './PatientHistoryContainer.style';

const { Collapse, IconButton } = MaterialUICore;

const { RecentActors, ExpandLess, ExpandMore } = MaterialIcons;

const PatientHistoryContainer = () => {
  const classes = useStyles();

  const [isOpen, setIsOpen] = useState(true);
  const [shouldRenderContent, setShouldRenderContent] = useState(isOpen);

  const handleCollapse = () => {
    setIsOpen((value) => !value);

    if (!shouldRenderContent) {
      setShouldRenderContent(true);
      return;
    }

    setTimeout(() => setShouldRenderContent(false), 300);
  };

  const collapseIndicator = isOpen ? <ExpandLess /> : <ExpandMore />;
  const titleBottomMargin = isOpen ? 3 : 0;

  return (
    <Paper elevation={2}>
      <Box
        mb={titleBottomMargin}
        className={classes.title}
        flexDirection="row"
        display="flex"
        justifyContent="space-between"
      >
        <SectionTitle
          title="Histórico e antecedentes"
          mb={0}
          icon={<RecentActors />}
          onClick={handleCollapse}
        />
        <Box>
          <IconButton onClick={handleCollapse}>{collapseIndicator}</IconButton>
        </Box>
      </Box>
      <Collapse in={isOpen}>
        {shouldRenderContent && (
          <>
            <PatientHistoryQuestion
              questionKey={PatientHistoryQuestionKey.clinicalBackground}
            />
            <PatientHistoryQuestion
              questionKey={PatientHistoryQuestionKey.medication}
            />
            <PatientHistoryQuestion
              questionKey={PatientHistoryQuestionKey.surgicalHistory}
            />
            <PatientHistoryQuestion
              questionKey={PatientHistoryQuestionKey.allergies}
            />
            <PatientHistoryQuestion
              questionKey={PatientHistoryQuestionKey.habits}
            />
            <PatientHistoryQuestion
              questionKey={PatientHistoryQuestionKey.familyBackground}
            />
          </>
        )}
      </Collapse>
    </Paper>
  );
};

export default React.memo(PatientHistoryContainer);
